import React from "react";
import { useTranslation } from 'react-i18next';

function createDynamicTag(tagName, props, children) {
  const Tag = tagName;

  return <Tag {...props}>{children}</Tag>;
}
function create_list_ptag(item){
  let tag_data;
  let tag_inner;
  if(item.other_option != undefined){
   let innerItem =  item.other_option ;
  
   innerItem.forEach((itemchild, index) => {
    tag_inner = createDynamicTag(itemchild.tag_name,itemchild.props_data,itemchild.title);
    tag_inner = (<>{itemchild.contain_before}{tag_inner}{itemchild.contain_after}</>)
    tag_data = (<>{tag_data}{tag_inner}</>);
});
  }
 let all_data = item.title;

 return (
  <>
      {all_data} {tag_data}
  </>
);
}
const Termsandcondition = ({details_pargs}) => {
  const { t, i18n } = useTranslation()
  
  return (

    <section className="about-content-section team-more-content policy-contents-section">
            <div className="container">
        <div className="about-content-wrapper d-flex justify-content-between align-items-center">
            <div className="about-content">
            <div className="policy-content">
                <h3>{t("Laws_and_Regulations")}</h3>
                <p>{t("Access_to_and_use_of_this_Site_is_subject")}</p>
                <h3>{t("Copyright_and_Trademarks")}</h3>
                <p>{t("The_information_available")}</p>
                <h3>{t("Third_Party_Information")}</h3>
                <p>{t("Although_CHRIST_FOR_ALL_NATIONS")}</p>                
                <h3>{t("Links_to_Third_Party_Sites")}</h3>
                <p>{t("This_Site_may_contain_links_that")}</p>                
                <h3>{t("Links_From_Third_Party_Sites")}</h3>
                <p>{t("CHRIST_FOR_ALL_NATIONS_CFAN_prohibits_unauthorized")}</p>                
                <h3>{t("No_Warranties")}</h3>
                <p>{t("Information_and_documents_provided_on_this_Site")}</p>
                <h3>{t("Limitation_of_Liability")}</h3>
                <p>{t("Under_no_circumstances_shall_christ_for_all_nations")}</p>                
                <h3>{t("Privacy")}</h3>
                <p>{t("Protecting_the_privacy_of_our_clients")}</p>
                <h3>{t("Google_Analytics")}</h3>
                <p>{t("We_use_a_tool_called_Google_Analytics_to_collect_information_about")}</p>
                <h3>{t("Transmission_of_Personal_Data")}</h3>
                <p>{t("User_acknowledges_and_agrees_that_by_providing_CHRIST_FOR_ALL_NATIONS")}</p>
                <h3>{t("Access_to_Password_Protected_Secure_Areas")}</h3>
                <p>{t("Access_to_and_use_of_password_protected")}</p>
                <h3>{t("Jurisdiction_Governing_Law")}</h3>
                <p>{t("These_terms_and_conditions_shall_be_governed")}</p>
            </div>        
            </div>
         </div>
         </div>
  </section>
  );
};

export default Termsandcondition;